import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import About from "./views/About.vue";
import Unsubscribe from "./views/Unsubscribe.vue";
import DeleteAccount from "./views/DeleteAccount.vue";
import SetDomain from "./views/SetDomain.vue";

Vue.use(Router);

const router = new Router({
  base: 'subscription',
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/logout",
      beforeEnter(to, from, next) {
        store.commit("logout");
        store.state.axios.post("api/auth/logout").finally(() => next("/"));
      }
    },
    {
      path: "/about",
      name: "About",
      component: About
    },
    {
      path: "/set-domain",
      name: "Domain",
      component: SetDomain
    },
    {
      path: "/delete-account",
      name: "DeleteAccount",
      component: DeleteAccount,
      // beforeEnter(to, from, next) {
      //   store.dispatch("isLoggedIn").then(x => {
      //     if (x)
      //       return next();
      //     else
      //       return next({
      //         path: '/login',
      //         query: {
      //           redirect: '/delete-account'
      //         }
      //       });
      //   });
      // }
    },
    {
      path: "/unsubscribe",
      name: "Unsubscribe",
      component: Unsubscribe,
      beforeEnter(to, from, next) {
        store.dispatch("isLoggedIn").then(x => {
          if (x)
            return next();
          else
            return next({
              path: '/login',
              query: {
                redirect: '/unsubscribe'
              }
            });
        });
      }
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (from.query.redirect) {
    var redirectTo = from.query.redirect;
    from.query.redirect = null;
    return next({ path: redirectTo });
  } 
  if (to.query.tkn) {
    switch (to.query["tkn-action"].toLowerCase()) {
      case "verify":
        return store.state.axios.post("api/auth/verify", { token: to.query.tkn })
          .catch(err => {
            if (err.response) {
              if (err.response.status == 401) {
                store.commit("setNotification", {
                  type: "error",
                  message: "Sorry, something went wrong when activating your account. Please make sure you only use the most recent link you received"
                })
              } else {
                store.commit("setNotification", {
                  type: "error",
                  message: "Sorry, something went wrong when activating your account."
                })
              }
            } else {
              store.commit("setNotification", {
                type: "error",
                message: "There was a connection error when we tried to activate your account. Please make sure you're online and follow the email link again"
              })
            }
          }).finally(() => next("/"));
      case "auth":
      default:
        return store.dispatch("authenticateWithToken", to.query.tkn)
          .catch(err => {
            if (err.response) {
              store.commit("setNotification", {
                type: "error",
                message: "Sorry, something went wrong when validating the link you followed"
              })
            } else {
              store.commit("setNotification", {
                type: "error",
                message: "There was a connection error when we tried to validate the link you followed. Please make sure you're online and follow the link again"
              })
            }
          }).finally(() => next("/"));
    }

  }
  if (to.query.unsubscribe)
    return next("/unsubscribe")
  return next();
})

router.beforeResolve((to, from, next) => {
  store.dispatch("isLoggedIn").then(x => {
    if (to.path == "/login" && x)
      next("/");
    else
      next();
  });
  
});
export default router;
